const scenario_scout = [
  {
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"e3d024f0-d7d4-4997-a0cb-5a7f4387bc6e",
    "beforenodeX":91,
    "beforenodeY":53,
    "start_flg":true,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":2
    },
    "parameter":[],
    "mainmessage":"$1\u3078\u3054\u8a2a\u554f\u9802\u304d\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3059\u3002\n\u3053\u3061\u3089\u304b\u3089\u304a\u554f\u3044\u5408\u308f\u305b\u3092\u53d7\u3051\u4ed8\u3051\u3066\u304a\u308a\u307e\u3059\u3002",
    "status":2,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"59d5f22a-e85a-4df5-ae91-8b3c58cc22e4",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":false,
    "is_confirm":false,
    "pk":30189
  },
  {
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"59d5f22a-e85a-4df5-ae91-8b3c58cc22e4",
    "beforenodeX":90,
    "beforenodeY":159,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":6
    },
    "parameter":{
      "colomn_name":"\u540d\u524d",
      "input_type":"free",
      "custom_tag":"",
      "custom":"",
      "default_birth":"",
      "date_type":"",
      "apply_flg":false,
      "any_flg":false,
      "default_flg":false,
      "keep_time_hour":0,
      "keep_time_minute":0
    },
    "mainmessage":"\u304a\u540d\u524d\u3092\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044[input][/input]",
    "status":6,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"359531ef-e592-4d90-893e-a81bccffd814",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":true,
    "is_confirm":false,
    "pk":30190
  },
  {
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"359531ef-e592-4d90-893e-a81bccffd814",
    "beforenodeX":444,
    "beforenodeY":160,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":6
    },
    "parameter":{
      "colomn_name":"Email",
      "input_type":"free",
      "custom_tag":"",
      "custom":"",
      "default_birth":"",
      "date_type":"",
      "apply_flg":false,
      "any_flg":false,
      "default_flg":false,
      "keep_time_hour":0,
      "keep_time_minute":0
    },
    "mainmessage":"Email\u3092\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044[input][/input]",
    "status":6,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"a04139eb-de2b-41f1-a0ea-5453ff464360",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":true,
    "is_confirm":false,
    "pk":30191
  },
  {
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"a04139eb-de2b-41f1-a0ea-5453ff464360",
    "beforenodeX":784,
    "beforenodeY":161,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":6
    },
    "parameter":{
      "colomn_name":"TEL",
      "input_type":"free",
      "custom_tag":"",
      "custom":"",
      "default_birth":"",
      "date_type":"",
      "apply_flg":false,
      "any_flg":false,
      "default_flg":false,
      "keep_time_hour":0,
      "keep_time_minute":0
    },
    "mainmessage":"\u96fb\u8a71\u756a\u53f7\u3092\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044[input][/input]",
    "status":6,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"181f2a8e-eedf-4d01-bf5b-e59b0b40d66f",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":true,
    "is_confirm":false,
    "pk":30192
  },
  {
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"181f2a8e-eedf-4d01-bf5b-e59b0b40d66f",
    "beforenodeX":1130,
    "beforenodeY":162,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":6
    },
    "parameter":{
      "colomn_name":"\u8a2d\u5b9a\u306a\u3057",
      "input_type":"free",
      "custom_tag":"",
      "custom":"",
      "default_birth":"",
      "date_type":"",
      "apply_flg":false,
      "any_flg":false,
      "default_flg":false,
      "keep_time_hour":0,
      "keep_time_minute":0
    },
    "mainmessage":"\u304a\u554f\u3044\u5408\u308f\u305b\u5185\u5bb9\u3092\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044[input][/input]",
    "status":6,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"f4602fab-500c-4998-b34b-0739f50810af",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":true,
    "is_confirm":false,
    "pk":30193
  },
  {
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"f4602fab-500c-4998-b34b-0739f50810af",
    "beforenodeX":87,
    "beforenodeY":269,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":10
    },
    "parameter":{
      "title":"\u304a\u554f\u3044\u5408\u308f\u305b\u304c\u3042\u308a\u307e\u3057\u305f",
      "to":"",
      "cc":"",
      "after":0
    },
    "mainmessage":"<p>\u3054\u62c5\u5f53\u8005\u69d8</p><p><br></p><p>\u304a\u4e16\u8a71\u306b\u306a\u3063\u3066\u304a\u308a\u307e\u3059\u3002</p><p>\u30a2\u30f3\u30b1\u30fc\u30c8\u306e\u56de\u7b54\u304c\u3054\u3056\u3044\u307e\u3057\u305f\u306e\u3067</p><p>\u3054\u78ba\u8a8d\u306e\u307b\u3069\u3088\u308d\u3057\u304f\u304a\u9858\u3044\u3044\u305f\u3057\u307e\u3059\u3002</p><p><br></p><p>---</p><p><br></p><p>\u304a\u540d\u524d\uff1a__applicant__</p><p>Email\uff1a__email__</p><p>TEL\uff1a__tel__</p>",
    "status":10,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"f0384a27-3422-4777-ad66-608546d55d41",
        "point":"",
        "content":""
      }
    ],
    "template":"",
    "is_cv":true,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":false,
    "is_confirm":false,
    "pk":30194
  },
  {
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"f0384a27-3422-4777-ad66-608546d55d41",
    "beforenodeX":95,
    "beforenodeY":383,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":0
    },
    "parameter":[],
    "mainmessage":"\u3054\u8a18\u5165\u9802\u304d\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3057\u305f\u3002\n\u62c5\u5f53\u304b\u3089\u3054\u9023\u7d61\u3044\u305f\u3057\u307e\u3059\u306e\u3067\u4eca\u3057\u3070\u3089\u304f\u304a\u5f85\u3061\u304f\u3060\u3055\u3044\u3002",
    "status":0,
    "select":[
      {
        "msg_type":"button",
        "message":"\u6700\u521d\u3078\u623b\u308b",
        "text_option":"white",
        "next_node":"3b2c444d-d55d-49e6-86b6-a59203aea9e1",
        "point":"0"
      }
    ],
    "template":"[button]\u6700\u521d\u3078\u623b\u308b,white[/button]",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":false,
    "is_confirm":false,
    "pk":30195
  },
  {
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"3b2c444d-d55d-49e6-86b6-a59203aea9e1",
    "beforenodeX":448,
    "beforenodeY":437,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":9
    },
    "parameter":[],
    "mainmessage":"[restart][/restart]",
    "status":9,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":false,
    "is_confirm":false,
    "pk":30196
  }
]

export {
  scenario_scout
}


// WEBPACK FOOTER //
// ./src/assets/data/tutorial_scenario_scout.js